module.exports = __webpack_public_path__ + "img/arrow.39c4c28a.svg";